'use client';
import ShareSocial from '@/components/share-social/share-social';
import styles from './share-modal.module.css';
import Modal from '@/components/modal/modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faLinkedin,
	faSquareFacebook,
	faSquareWhatsapp,
	faSquareXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import {
	faEnvelope,
	faShare,
} from '@awesome.me/kit-012d1b9af0/icons/classic/regular';
import useModal from '../use-modal';

export default function ShareModal({
	nctId,
	trialTitle,
}: {
	nctId?: string;
	trialTitle: string;
}) {
	const { onOpen, isOpen, onClose } = useModal();
	if (!nctId) return;

	return (
		<>
			<div className={styles.share} onClick={() => onOpen('share-modal')}>
				<FontAwesomeIcon icon={faShare} color='#fff' size='xl' />
			</div>

			<Modal
				isOpen={isOpen('share-modal')}
				onClose={() => onClose('share-modal')}
				auto
			>
				<Modal.Title>
					<div className={styles['dialog-title']}>Share The Trial</div>
				</Modal.Title>
				<Modal.Body>
					<div className={styles.body}>
						<ShareSocial
							wrapper='facebook'
							url={`${process.env.NEXT_PUBLIC_BASE_URL}/trial/${nctId}`}
						>
							<div
								className={styles['share-container']}
								style={{
									background: '#1877F2',
								}}
							>
								<p style={{ color: '#fff' }}>Share on Facebook</p>
								<FontAwesomeIcon
									icon={faSquareFacebook}
									size='2xl'
									color='#fff'
								/>
							</div>
						</ShareSocial>
						<ShareSocial
							wrapper='twitter'
							url={`${process.env.NEXT_PUBLIC_BASE_URL}/trial/${nctId}`}
						>
							<div
								className={styles['share-container']}
								style={{
									background: '#000000',
								}}
							>
								<p style={{ color: '#fff' }}>Share on Twitter</p>
								<FontAwesomeIcon
									icon={faSquareXTwitter}
									size='2xl'
									color='#fff'
								/>
							</div>
						</ShareSocial>
						<ShareSocial
							wrapper='whatsapp'
							url={`${process.env.NEXT_PUBLIC_BASE_URL}/trial/${nctId}`}
						>
							<div
								className={styles['share-container']}
								style={{
									background: '#25D366',
								}}
							>
								<p style={{ color: '#fff' }}>Share on Whatsapp</p>
								<FontAwesomeIcon
									icon={faSquareWhatsapp}
									size='2xl'
									color='#fff'
								/>
							</div>
						</ShareSocial>
						<ShareSocial
							wrapper='linkedin'
							url={`${process.env.NEXT_PUBLIC_BASE_URL}/trial/${nctId}`}
						>
							<div
								className={styles['share-container']}
								style={{
									background: '#2867B2',
								}}
							>
								<p style={{ color: '#fff' }}>Share on LinkedIn</p>
								<FontAwesomeIcon icon={faLinkedin} size='2xl' color='#fff' />
							</div>
						</ShareSocial>
						<ShareSocial
							wrapper='email'
							url={`${process.env.NEXT_PUBLIC_BASE_URL}/trial/${nctId}`}
							subject={`SCI Trial - ${trialTitle}`}
							body={`Hi,

Have you seen this spinal cord injury trial on SciTrials.org?

Non-Invasive Interventions for Respiratory Recovery in Chronic Spinal Cord Injury
`}
						>
							<div
								className={styles['share-container']}
								style={{
									background: '#777777',
								}}
							>
								<p style={{ color: '#fff' }}>Share on Email</p>
								<FontAwesomeIcon icon={faEnvelope} size='2xl' color='#fff' />
							</div>
						</ShareSocial>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className={styles.footer}>
						<button
							type='button'
							className={styles.cancel}
							onClick={() => onClose('share-modal')}
						>
							Cancel
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
}
